/**
 * Map groups to sortable tree needed by library
 *
 * @param {array} groups
 * @returns {[]}    - array of groups
 */
export const mapGroupsToSortableTree = groups => {
    let mappedGroups = []

    function findById(data, id) {
        function iterationFind(group) {
            if (group.id === id) {
                result = group
                return true
            }
            return Array.isArray(group.children) && group.children.some(iterationFind)
        }

        let result
        data.some(iterationFind)
        return result
    }

    groups
        .sort((groupA, groupB) => groupA.level - groupB.level)
        .map(group => {
            return {
                title: group.name,
                level: group.level,
                id: group.id,
                parent: group.parent,
                slug: group.slug,
                children: [],
                expanded: true,
            }
        })
        .forEach(group => {
            if (!group.parent) {
                // If group dont have parent, just add it
                mappedGroups.push(group)
            } else {
                // Find group parent in tree
                let parentGroup = findById(mappedGroups, group.parent)

                // If group have parent into groups, add children
                if (parentGroup) {
                    parentGroup.children.push(group)
                } else {
                    // Else group have parent but user is not allowed to edit it
                    mappedGroups.push(group)
                }
            }
        })

    return mappedGroups
}

/**
 * Map sortable tree to simple groups
 *
 * @param {Array} tree
 * @returns {Array}
 */
export const mapSortableTreeToSimpleGroups = tree => {
    let result = []

    /**
     * Process recursively full tree into flat tree with level and order
     *
     * @param {Array} groups
     * @param {Number} level
     */
    let processTree = (groups, level = 0) => {
        groups.forEach((group, index) => {
            group.level = level
            group.order = index
            result.push(group)

            if (group.children.length > 0) {
                return processTree(group.children, level + 1)
            }
        })
    }

    processTree(tree)

    return result.sort((groupA, groupB) => groupA.level - groupB.level)
}
